// AI Generated File
import { Component, Input, OnInit, OnChanges, EventEmitter, Output } from '@angular/core';
import { HeatmapService } from '@client/app/modules/heatmaps/services/heatmap.service';
import { HeatmapApiService } from '@client/app/services/entities/heatmaps/heatmaps.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { SessionService } from '@monsido/core/session/session.service';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'heatmaps-dashboard-table',
    standalone: false,
    template: `
        <heatmaps-dialogs-pages
            [show]="showSearch"
            [selectedRule]="selectedRule"
            [rules]="rules"
            (close)="onClosePageSearch($event)">
        </heatmaps-dialogs-pages>
        <div class="row mb-2" *ngIf="['customer_admin'] | monRole">
            <div class="ml-auto col-auto">
                <button class="btn btn-border-radius btn-secondary py-2 px-3"
                        [ngbTooltip]="'Add Heatmap rule to a Page' | translate"
                        [triggers]="'focus hover'"
                        [disabled]="!canAddMoreRules()"
                        type="button"
                        (click)="addRule()">
                    <span class="fas fa-plus" aria-hidden="true"></span>
                    <span class="sr-only" translate>Add Heatmap rule to a Page</span>
                </button>
            </div>
        </div>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <mon-spinner [loading]="loading">
                    <table-container [collection]="rules"
                                     (onPageChange)="onPageChange.emit({page: $event})"
                                     (onPerPageChange)="onPerPageChange.emit({size: $event})">
                        <table class="table table-hover table-fixed">
                            <thead>
                            <tr>
                                <th class="col-md-24" translate>URL & Title</th>
                                <th class="col-md-12" translate>Domain</th>
                                <th class="col-5 col-md-12" *ngIf="['customer_admin'] | monRole">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let rule of rules">
                                <td class="text-v-middle text-ellipsis py-2">
                                    <url-title [title]="rule.page.title" [url]="rule.page.url" [active]="false"></url-title>
                                </td>
                                <td class="text-v-middle text-ellipsis py-2">
                                    <url-title [title]="domains[rule.id]?.title"
                                            [url]="domains[rule.id]?.url"
                                            [active]="false">
                                    </url-title>
                                </td>
                                <td class="text-right text-v-middle" *ngIf="['customer_admin'] | monRole">
                                    <div class="d-flex justify-content-end flex-wrap">
                                        <mon-action-menu [monActionMenuItems]="rule.dropdown">
                                            <span translate>Action</span>
                                        </mon-action-menu>
                                        <mon-extension-visual-link-button class="ml-3" [page]="rule.page" [type]="'heatmaps'">
                                        </mon-extension-visual-link-button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </mon-spinner>
            </div>
        </div>
    `,
})
export class HeatmapsDashboardTableComponent implements OnInit, OnChanges {
    @Input() rules: any;
    @Input() loading: any;
    @Input() domains: any;

    @Output() getPage = new EventEmitter();
    @Output() onPageChange = new EventEmitter();
    @Output() onPerPageChange = new EventEmitter();

    showSearch: boolean = false;
    selectedRule: any = null;

    constructor (
        private heatmapService: HeatmapService,
        private heatmapApiService: HeatmapApiService,
        private monDialog: MonDialog,
        private sessionService: SessionService,
        private translateService: TranslateService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngOnChanges (changes: any): void {
        if (changes.rules) {
            this.updateDropdowns();
        }
    }

    activate (): void {
        this.showSearch = false;
        this.selectedRule = null;
    }

    updateDropdowns (): void {
        for (let i = 0; i < this.rules.length; i++) {
            const rule = this.rules[i];

            const dropdown = [
                {
                    label: this.translateService.getString('Replace Rule'),
                    leftIcon: 'faRetweet',
                    action: () => this.updateRule(rule),
                },
                {
                    label: this.translateService.getString('Remove Rule'),
                    leftIcon: 'faTrashAlt',
                    action: () => this.removeRule(rule, i),
                },
            ];

            this.rules[i].dropdown = dropdown;
        }
    }

    removeRule (rule: any, index: number): void {
        this.heatmapService.confirmDelete(rule).then(() => {
            this.heatmapApiService.destroy(rule.domain_id, rule.id).then(() => {
                this.rules.splice(index, 1);
            }, () => {});
        }, () => {});
    }

    updateRule (rule: any): void {
        this.selectedRule = rule;
        this.showSearch = true;
    }

    addRule (): void {
        this.selectedRule = null;
        this.showSearch = true;
    }

    canAddMoreRules (): boolean {
        if (this.sessionService.customer) {
            return this.sessionService.customer.plan_traits.heatmaps_tracked_number_of_pages > this.rules.length;
        }
        return false;
    }

    onClosePageSearch (rule: any): void {
        if (rule || (rule && this.selectedRule)) {
            this.getPage.emit();
        }
        this.showSearch = false;
        this.selectedRule = null;
    }
}
